import axios from 'axios';

axios.defaults.baseURL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5000'
  : 'https://medicare0417-94a6ea368fe9.herokuapp.com/';

export * as api from './api';
export { useAPI } from './shared';
